import { useState } from "react";
import { useLocation } from "react-router-dom";
import style from "../../styles/inputGrid.module.css";
import "../../styles/comprastyles.css";
import { GetInsumos } from "../../actions/Insumo";
import ImagenCerrar from "../../images/cerrar.png";
// const itemsList = [
//   { id: 1, descripcion: "Item A", stock: 10, dolar: 100 },
//   { id: 2, descripcion: "Item B", stock: 5, dolar: 200 },
//   { id: 3, descripcion: "Item C", stock: 8, dolar: 150 },
// ];
export default function ItemForm() {
   const hoy = new Date();
   const location = useLocation();
   const token = localStorage.getItem("token");
   const { state } = location;
   const itemsList = GetInsumos();
   const [inputs, setInputs] = useState({});
   const [cart, setCart] = useState([]);
   const [ttitulo, setTtitulo] = useState("");
   const urlCompra = process.env.REACT_APP_URL_DIR 
   var verInsumo = false
   // eslint-disable-next-line no-unused-vars
   const [input, setInput] = useState({
      tabla: state ? state.tabla : "",
      id: state ? state.id : 0,
      id_primary: state ? state.id_primary : 0,
      fecha: hoy.toISOString().split("T")[0],
      tipo: 2,
      titulo: state ? state.titulo : "",
      total: state ? state.total : 0,
      compra: state ? state.compra : [],
      hecho: 0,
   });
   console.log("input: ", input);
   // Pongo datos de la compra
   if (input.id_primary > 0 && cart.length === 0 && input.hecho === 0) {
      console.log("input.compra: ", input.compra);
      setTtitulo(input.titulo)
      // const newcart = input.compra.map((compraItem) => ({
      //    id: compraItem.id,
      //    tipo: compraItem.tipo,
      //    descripcion: compraItem.descripcion,
      //    presentacion: compraItem.presentacion,
      //    porcentaje: compraItem.porcentaje,
      //    amount: compraItem.comprainsumo.cantidad,
      //    dolar: parseFloat(compraItem.comprainsumo.precio),
      //    total: parseFloat(compraItem.comprainsumo.precio),
      // }));
      const newcart = input.compra.map((compraItem) => {
         const amount = compraItem.comprainsumo.cantidad;
         const dolar = parseFloat(compraItem.comprainsumo.precio);
         let total;
         if (compraItem.tipo === 1) {
            total = dolar / amount;
         } else {
            // total = parseFloat(
            //    ((dolar / amount) * compraItem.presentacion) / 100
            // );
            total = parseFloat(
               (((dolar * compraItem.consumo) / compraItem.presentacion )/amount)
            );               
         }
         return {
            id: compraItem.id,
            tipo: compraItem.tipo,
            descripcion: compraItem.descripcion,
            presentacion: compraItem.presentacion,
            porcentaje: compraItem.porcentaje,
            consumo: compraItem.consumo,
            amount,
            dolar,
            total,
         };
      });
      // Populate inputs for each item in newcart
      const newInputs = {};
      newcart.forEach((item) => {
         console.log("item: ", item);
         newInputs[item.id] = {
            amount: item.amount,
            dolar: item.dolar,
         };
      });
      setInputs(newInputs);

      console.log("newcart: ", newcart);
      setCart(newcart);

      console.log("inputs: ", inputs);
      input.hecho = 1;
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      console.log("cart: ", cart);
      const url =
         input.id === 0
            ? urlCompra + input.tabla
            : process.env.REACT_APP_URL_DIR + `sqlraw/compra`;
      const metodo = input.id === 0 ? "POST" : "PUT";
      input.titulo = ttitulo || "Compra de Insumos";
      input.total = cart.reduce((acc, item) => acc + item.dolar, 0).toFixed(2);
      input.compra = cart.map((item) => ({
         id: item.id,
         cantidad: item.amount,
         precio: item.dolar,
         total: item.total,
         presentacion: item.presentacion,
         porcentaje: item.porcentaje,
      }));
      console.log("input.total : ", input);
      console.log("url: ", metodo, url);
      fetch(url, {
         method: metodo,
         body: JSON.stringify(input),
         headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
         },
      }).then((res) => res.json());
      input.titulo = "";
      input.total = 0;
      input.insumos = [];
      input.compra = [];
      window.location.href = "/CompraIns";
   };

   const handleInputChange = (id, field, value) => {
      const newInputs = {
         ...inputs,
         [id]: {
            ...inputs[id],
            [field]: value,
         },
      };
      setInputs(newInputs);

      const item = itemsList.find((i) => i.id === id);
      const amount = parseFloat(newInputs[id]?.amount || 0);
      const newdolar = parseFloat(newInputs[id]?.dolar || item.dolar);

      if (amount > 0) {
         const updatedItem = {
            id,
            descripcion: item.descripcion,
            presentacion: item.presentacion,
            porcentaje: item.porcentaje,
            consumo: item.consumo,
            stock: item.stock,
            amount,
            dolar: newdolar,
            total: newdolar/ amount 
         };
         if (item.presentacion !== 1) {
            console.log("newdolar: ", newdolar);
            console.log('item.consumo: ', item.consumo);
            console.log("presentacion: ", item.presentacion);
            // console.log("amount: ", amount);
            // console.log("item: ", item.tipo);
            // console.log("1: ", newdolar / amount);
            // console.log("2: ", (newdolar / amount) * item.presentacion);
            // updatedItem.total = parseFloat(
            //    ((newdolar / amount) * item.presentacion) / 100
            // );
            updatedItem.total = parseFloat(
               // (((newdolar * item.consumo) / item.presentacion ) / amount)
               ((item.consumo*newdolar)/item.presentacion/amount)
            );            
            console.log("updatedItem.total: ", updatedItem.total);
         }

         const exists = cart.find((c) => c.id === id);
         if (exists) {
            setCart(cart.map((c) => (c.id === id ? updatedItem : c)));
         } else {
            setCart([...cart, updatedItem]);
         }
      }
   };

   const removeFromCart = (id) => {
      setCart(cart.filter((item) => item.id !== id));
      setInputs({ ...inputs, [id]: { amount: "", dolar: "" } });
   };
   console.log("cart: ", cart);
   return (
      <div className="form-container">
         <div className="list">
            <h2>Insumos Piercing</h2>
            <table>
               <thead>
                  <tr>
                     <th>Descripcion</th>
                     <th>Precio por Unidad</th>
                     <th>Stock</th>
                     <th colSpan={2}>Cantidad de unidades</th>
                     <th>Precio Total</th>
                  </tr>
               </thead>
               <tbody>
                  {itemsList?.map((item) => {
                     verInsumo= false
                     if (item.tipo === 1) verInsumo=true
                     if (item.tipo === 3) verInsumo=true
                     if (verInsumo) {
                        return (
                           <tr key={item.id}>
                              <td className={style.tdleft}>
                                 {item.descripcion}
                              </td>
                              <td className={style.precio}>
                                 ${item.dolar}&nbsp;
                              </td>
                              <td className={style.precio}>
                                 {item.stock}&nbsp;
                              </td>
                              <td>
                                 <input
                                    type="number"
                                    value={inputs[item.id]?.amount || ""}
                                    onChange={(e) =>
                                       handleInputChange(
                                          item.id,
                                          "amount",
                                          e.target.value
                                       )
                                    }
                                 />
                              </td>
                              <td className={style.tdotro}>
                                 &nbsp;{item.presdescrip}&nbsp;
                              </td>
                              <td>
                                 <input
                                    type="number"
                                    value={inputs[item.id]?.dolar || ""}
                                    onChange={(e) =>
                                       handleInputChange(
                                          item.id,
                                          "dolar",
                                          e.target.value
                                       )
                                    }
                                 />
                              </td>
                           </tr>
                        );
                     }
                     return null;
                  })}
               </tbody>
            </table>
         </div>

         <div className="list">
            <h2>Insumos Seleccionados</h2>
            <table>
               <thead>
                  <tr>
                     <th>Descripcion</th>
                     <th>Cantidad</th>
                     <th>Total</th>
                     <th>Valor Unidad</th>
                     <th>Accion</th>
                  </tr>
               </thead>
               <tbody>
                  {cart?.map((item) => (
                     <tr key={item.id}>
                        <td className={style.tdleft}>{item.descripcion}</td>
                        <td className={style.precio}>{item.amount}</td>
                        <td className={style.precio}>${item.dolar}</td>
                        <td className={style.precioLong}>
                           ${item.total.toFixed(2)}
                           &nbsp;
                        </td>
                        <td>
                           <img
                              onClick={() => removeFromCart(item.id)}
                              src={ImagenCerrar}
                              height="30px"
                              alt=""
                           />
                           {/* <button onClick={() => removeFromCart(item.id)}>Remove</button> */}
                        </td>
                     </tr>
                  ))}
                  {cart.length === 0 && (
                     <tr>
                        <td colSpan="5">Seleccione un item</td>
                     </tr>
                  )}
               </tbody>
               {cart.length > 0 && (
                  <>
                     <tr>
                        <td colSpan="2">Total:</td>
                        <td>
                           $
                           {cart
                              .reduce((acc, item) => acc + item.dolar, 0)
                              .toFixed(2)}
                        </td>
                        <td colSpan="2"></td>
                     </tr>
                     <tr>
                        <td>Descripcion</td>
                        <td colSpan={5}>
                              <input
                                 className={style.inputDescripcion}
                                 type="text"
                                 placeholder="Titulo de la compra"
                                 value={ttitulo}
                                 onChange={(e) => setTtitulo(e.target.value)}
                              />
                        </td>
                     </tr>
                     <tr>
                        <td colSpan="2">
                           <button onClick={(e) => handleSubmit(e)}>
                              Realizar Compra
                           </button>
                        </td>
                        <td colSpan="2">&nbsp;</td>
                        <td>
                           <button
                              onClick={() => {
                                 window.location.href = "/CompraIns";
                              }}
                           >
                              VOLVER
                           </button>
                        </td>
                     </tr>
                  </>
               )}
            </table>
         </div>
      </div>
   );
}
